import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields, Checkbox } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { SiNoVacias, SiNo } from "app/features/selectores/index";

type Entity = models.EntregaOcurreFiltro;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

/**
* Valida un Entity
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = { };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class FiltroEntregaOcurreComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Date = getField(kea.DateTime);
        const Usuario = getField(selectores.Usuario);
        const Cliente = getField(selectores.Cliente);
        const Sucursal = getField(selectores.Sucursal);
        const SiNo = getField(selectores.SiNo);
        return (
            <div>
                {kea.autogrid(3, [
                    <Usuario field="IdUsuario" label="Usuario" />,
                    <Cliente field="IdCliente" label="Cliente" />,
                    <Sucursal field="IdSucursal" label="Sucursal" />,
                    <Date field="FechaInicio" label="Fecha (inicio)" />,
                    <Date field="FechaFinal" label="Fecha (final)" />,
                    <SiNo field="FxC" label="FxC" />,
                    <SiNo field="EsDecredito" label="Credito" />
                ])}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/ocurre/componentes/list/filtro.tsx